import React from 'react';

const StartRecordingSteps = () => {
	const steps = [
		{
			key: 1,
			stepNumber: '1',
			stepText: 'Record rooms with items to move'
		},
		{
			key: 2,
			stepNumber: '2',
			stepText: 'Our software creates moving list for you'
		},
		{
			key: 3,
			stepNumber: '3',
			stepText: 'You get an accurate quote based on your items'
		}
	];

	return (
		<div className='step-wrap'>
			<h5>It's easy -</h5>
			<div className='step-list'>
				{steps.map(step => (
					<div className='step' key={step.key}>
						<div className='step-number'>{step.stepNumber}</div>
						<div className='step-text'>
							<h6>{step.stepText}</h6>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default StartRecordingSteps;
